import { FC, useMemo } from 'react'
import VideoIcon from '../../assets/icons/Video.svg?react'
import VideoPlusIcon from '../../assets/icons/VideoPlus.svg?react'
import WalletIcon from '../../assets/icons/WalletAlt.svg?react'

type Props = {
    compact?: boolean
    eventCode: string
}

export const NotificationIcon: FC<Props> = ({ compact, eventCode }) => {
    const size = compact ? 16 : 20

    const icon = useMemo(() => {
        if (
            [
                'assistant_purchased',
                'plan_expired',
                'plan_changed',
                'balance_topped_up',
                'plan_activated',
                'topup_package_purchased',
                'autotopup_enabled',
                'autotopup_suspended_payment_failure',
                'subscription_ended_after_user_cancellation',
                'balance_zero_with_active_package',
                'autopay_upcoming_3d',
                'promo_activated',
            ].includes(eventCode)
        ) {
            return <WalletIcon width={size} height={size} color="#006CFD" />
        } else if (
            [
                'bot_added_to_meeting',
                'bot_connected_to_meeting',
                'meeting_transcription_started',
                'video_added_for_transcription',
                'video_transcription_started',
            ].includes(eventCode)
        ) {
            return <VideoPlusIcon width={size} height={size} color="#006CFD" />
        } else if (
            [
                'bot_disconnected_from_meeting',
                'meeting_transcription_completed',
                'meeting_transcription_failed',
                'video_transcription_completed',
                'video_transcription_failed',
                'meeting_deleted',
            ].includes(eventCode)
        ) {
            return <VideoIcon width={size} height={size} color="#006CFD" />
        }

        return null
    }, [eventCode, size])

    return (
        icon ?? (
            <img
                style={{
                    width: `${size}px`,
                }}
                src="/vector/logo13x13.svg"
            />
        )
    )
}
